import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import HomePage from './pages/HomePage'
import PresalePage from './pages/PresalePage'
import AirdropPage from './pages/AirdropPage'
import HistoryPage from './pages/HistoryPage'
import SettingsPage from './pages/SettingsPage'
import Navigation from './components/Navigation'
import { RainbowKitProvider, useWeb3Wallet } from './contexts/RainbowKitProvider'
import { VoiceProvider } from './contexts/VoiceContext'
import { TransactionProvider } from './contexts/TransactionContext'
import './index.css'

function AppContent() {
  const { isConnected } = useWeb3Wallet()

  return (
      <div className="h-screen overflow-hidden" style={{backgroundColor: '#e5aa17'}}>
        {/* Animated background effects */}
        <div className="fixed inset-0 overflow-hidden pointer-events-none">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-purple-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-blue-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
          <div className="absolute top-40 left-40 w-80 h-80 bg-pink-500 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-4000"></div>
        </div>

        {/* Header */}
        <header className="relative z-20 bg-black/20 backdrop-blur-sm border-b border-white/10">
          <div className="max-w-md mx-auto px-4 py-3">
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <img src="/Voice-128x128.svg" alt="Voice" className="w-10 h-10" />
                <div>
                  <h1 className="text-lg font-bold text-white">Voice</h1>
                  <p className="text-xs text-white/60">BNB Chain • {isConnected ? 'Connected' : 'Disconnected'}</p>
                </div>
              </div>
              <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M4 4a2 2 0 00-2 2v8a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2H4zm2 6a2 2 0 114 0 2 2 0 01-4 0zm8-2a2 2 0 100 4 2 2 0 000-4z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>
        </header>

        {/* Main content */}
        <div className="relative z-10 flex flex-col h-screen">
          <main className="flex-1 overflow-y-auto pb-20">
            <div className="max-w-md mx-auto px-4">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/presale" element={<PresalePage />} />
                <Route path="/airdrop" element={<AirdropPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/settings" element={<SettingsPage />} />
              </Routes>
            </div>
          </main>
          
          <Navigation />
        </div>


      </div>
  )
}

function App() {
  return (
    <RainbowKitProvider>
      <VoiceProvider>
        <TransactionProvider>
          <Router>
            <AppContent />
          </Router>
        </TransactionProvider>
      </VoiceProvider>
    </RainbowKitProvider>
  )
}

export default App